import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AguaBuscaCuentasService } from "../../servicios/agua-busca-cuentas.service";
import { AguaBuscaCuentas, AguaBuscaCuentasInput } from "../../entidades/entidades";
import { AguasService } from "../../servicios/aguas.service";
import { Aguas } from "../../entidades/entidades";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { CargosDetallesComponent } from "../cargos-detalles/cargos-detalles.component";
declare var $: any;
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-agua-busca-cuentas",
  templateUrl: "./agua-busca-cuentas.component.html",
  styleUrls: ["./agua-busca-cuentas.component.css"],
})
export class AguaBuscaCuentasComponent implements OnInit {
  private actionUrl: string;
  datosCuentaAguaForm: FormGroup;
  datosAguaCuenta = new AguaBuscaCuentasInput();
  datosAguas = new Aguas();
  @Input() mostrarCuenta: boolean = true;
  @Input("aguaBuscaCuentas") aguaBuscaCuentas: EventEmitter<AguaBuscaCuentas>;
  //@Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;
  @Output("aguasOutput") aguasOutput: EventEmitter<number>;
  @ViewChild('cuentaInput') cuentaInput!: ElementRef;
  @Input() validaSiEstaCalculando: boolean = false;


  buscando: boolean = false;
  ventana: boolean = true;
  muestraMensaje = new MuestraMensaje();

  busquedaDiferente:AguaBuscaCuentas;

  constructor(
    private formBuilder: FormBuilder,
    private aguasService: AguasService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService,
    private router: Router,
  ) {
    this.aguasOutput = new EventEmitter();
    this.aguaBuscaCuentas = new EventEmitter();
  }

  ngOnInit() {
    this.datosCuentaAguaForm = this.formBuilder.group({
      cuentaAgua: [undefined],
      nRazonSocialAgua: [undefined],
      domicilioAgua: [undefined],
      medidorAgua: [undefined],
    });
  }
  // Método para enfocar el input al cargar el componente
  ngAfterViewInit() {
    if (this.cuentaInput) {
      this.cuentaInput.nativeElement.focus();
    }
  }
  async buscaCuentaAgua() {
    if (this.buscando) {
      return;
    }
    try {

      this.buscando = true;
      
      //validamos si la cuenta esta en proceso de calculo
      if(this.validaSiEstaCalculando){
        const retorno = await this.aguasService.getCuenta(this.datosCuentaAguaForm.value.cuentaAgua).toPromise(); 
        if (retorno == null) {
          this.muestraMensaje.error('No existe el Contrato en el Padrón.', 'top', 'center');
          return;
        }


        let dato = JSON.parse(retorno.dato);
        if (dato['calculando']) {
          this.muestraMensaje.error('ESTE CONTRATO SE ENCUENTRA EN PROCESO DE CALCULO DE PERIODO.\nFAVOR DE ESPERAR UN MOMENTO Y CONSULTAR MÁS TARDE.', 'top', 'center');
          this.buscando = false;
          return
        };
      };

      this.aguasOutput.emit(null);
      this.aguaBuscaCuentas.emit(null);
      this.datosAguaCuenta.cuentaAgua = this.datosCuentaAguaForm.value.cuentaAgua;
      if (this.datosAguaCuenta.cuentaAgua == null) {
        this.muestraMensaje.error('Ingresa una cuenta para la busqueda', 'top', 'center'); return
      }
      const datoretorno = await this.aguaBuscaCuentasService.add(this.datosAguaCuenta).toPromise();

      if (Object.keys(datoretorno).length == 1) {
        this.getAguas(datoretorno[0].id);
        this.muestraMensaje.notification("Registro encontrado.", "top", "center");
      } else if (Object.keys(datoretorno).length >= 2) {
        this.aguaBuscaCuentas.emit(datoretorno);
        this.busquedaDiferente = datoretorno;
        
        this.datosCuentaAguaForm.reset();
        $("#exampleModalLong").modal()

      } else {
        //DatosAguaSolicitudes
        this.datosCuentaAguaForm.reset();
        this.muestraMensaje.error("No se encontró registro.", "top", "center");
      }
    


    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por AguaBuscaCuenta");
      this.buscando = false;
    }
  }

  async getAguas(id: number) {
    try {
      //const datoRetorno = await this.aguasService.getSingle(id).toPromise();
      //this.aguasOutput.emit(datoRetorno);
      this.aguasOutput.emit(id);
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getAguas");

    }
  }

  //async childAguaBuscaCuentasGrid(aguas: Aguas) {
    async childAguaBuscaCuentasGrid(idAguas: number) {
    $("#exampleModalLong").modal('hide')
    if (!idAguas) {
      this.aguasOutput.emit(null);
      return;
    }
    this.aguasOutput.emit(idAguas);

  }


  async limpia(){
    this.busquedaDiferente = null;
  }




}
